var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance=='mfar')?_c('a',{attrs:{"target":"_blank","href":_vm.getCauUrl()}},[_vm._v(_vm._s(_vm.$t('components.cau_link.tpl.cau'))),(_vm.showIcon)?_c('i',{staticClass:"fa fa-external-link ml-1"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }